import { Component } from "@angular/core";
import { FormBuilder, Validators, ReactiveFormsModule } from "@angular/forms";
import { AuthService } from "../../core/services/auth.service";
import { UserSettingsService } from "../../core/services/user-settings.service";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { ResetPasswordComponent } from "../../shared/reset-password/reset-password.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WSSyncFusionGridComponent } from "wspowerpack";
import { Query } from "@syncfusion/ej2-data";
import { NgIf } from "@angular/common";
import { ButtonComponent } from "../../shared/button/button.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: true,
  imports: [ButtonComponent, ReactiveFormsModule, NgIf],
})
export class LoginComponent {
  loginForm = this.formBuilder.group({
    login_username: ["", [Validators.required]],
    login_password: ["", [Validators.required]],
  });
  isPasswordVisible: boolean = false;
  login_error: string = "";
  public sharedGrid!: WSSyncFusionGridComponent;
  year: number = new Date().getFullYear();
  isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private authService: AuthService,
    private userSettingsService: UserSettingsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate([this.authService.getHome()]);
    }
  }

  async submit(): Promise<void> {
    this.login_error = "";

    if (this.loginForm.invalid) {
      this.login_error = "Enter email and password";
      return;
    }

    this.isLoading = true;

    let loginUsername = this.loginForm.controls["login_username"].value;
    let loginPassword = this.loginForm.controls["login_password"].value;
    if (loginUsername != null && loginPassword != null) {
      await this.authService.login(loginUsername, loginPassword).then(
        () => {
          if (this.authService.isLoggedIn()) {
            this.userSettingsService.getUserSettings();
            if (this.authService.user.isExpired) {
              this.router.navigateByUrl(
                this.authService.getHome().replace(
                  "/dashboard",
                  "/expired"
                )
              );
            } else if (this.authService.user.isDemo) {
                this.router.navigateByUrl(
                  this.authService.getHome().replace(
                    "/dashboard",
                    "/demo"
                  )
                );
              } else {
                //Reroute from redirect
                if (this.authService.redirectUrl != null)
                  this.router.navigateByUrl(
                    this.authService.redirectUrl.replace(
                      environment.clientRoot,
                      ""
                    )
                  );
                //Default
                else {
                  this.router.navigate([this.authService.getHome()]);
                }
              }
          } else {
            this.login_error =
              "You have entered an invalid username or password.";
            this.isLoading = false;
          }
        },
        () => {
          this.login_error =
            "You have entered an invalid username or password.";
          this.isLoading = false;
        }
      );
    }
  }

  onHelpClicked(): void {
    this.router.navigateByUrl("/contact");
  }

  onForgotPassword(): void {
    const modalRef = this.modalService.open(ResetPasswordComponent, {
      size: "lg",
    });
    modalRef.componentInstance.email =
      this.loginForm.controls["login_username"].value;
  }

  onCreateAccount(): void {
    this.authService.logout();
    this.router.navigateByUrl("/register");
  }

  getDefaultQuery(): Query {
    return new Query().where("parentAccountId", "equal", null);
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
